import { type FC } from "react";

import { HealthLogo, OuraLogo, WithingsLogo, YazioLogo } from "@/components/icons";
import { ChildCard, ComingSoonCard } from "@/components/molecules/ChildCard";

/**
 * **HealthApp**
 *
 * Zwischenebene für Health-Tools unter Nexus.
 * Zeigt verfügbare Health-Integrationen an.
 *
 * @returns {JSX.Element} Health app component with integration cards
 *
 */
export const HealthApp: FC = () => {
  return (
    <div className="min-h-screen bg-background p-6 space-y-6 text-primary">
      <header className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <HealthLogo size="app" />
          <h1 className="text-2xl font-bold">Health</h1>
        </div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Oura Card */}
        <ChildCard
          ctaText="View Dashboard"
          description="Monitor your sleep quality, readiness, activity, and recovery metrics with your Oura Ring."
          icon={<OuraLogo size="app" />}
          title="Oura Ring"
          to="/nexus/health/oura"
        />

        {/* Withings Card */}
        <ChildCard
          ctaText="View Dashboard"
          description="Track your weight, body composition, and health metrics with your Withings smart scale."
          icon={<WithingsLogo size="app" />}
          title="Withings Scale"
          to="/nexus/health/withings"
        />

        {/* Yazio Card */}
        <ChildCard
          ctaText="View Dashboard"
          description="Track your daily nutrition, macros, and calories with Yazio integration."
          icon={<YazioLogo size="app" />}
          title="Yazio Nutrition"
          to="/nexus/health/yazio"
        />

        {/* Future Health Tools */}
        <ComingSoonCard
          description="Additional health and wellness integrations will be available here."
          gradient={{ from: "from-neutral-600", to: "to-neutral-700" }}
          iconLetter="+"
          title="More Tools"
        />
      </div>
    </div>
  );
};
